import React from "react";
import { useNavigate } from "react-router-dom";
import "../Styling/AppCard.css";

const AppCard = ({
  appName,
  description,
  triesRemaining,
  icon,
  navigateTo,
}) => {
  const navigate = useNavigate();

  const handleTestApp = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  return (
    <div className="app-card">
      <div className="app-card-left">
        <img src={icon} alt={appName} className="app-card-icon" />
      </div>
      <div className="app-card-center">
        <h3 className="app-card-title">{appName}</h3>
        <p className="app-card-description">{description}</p>
        <p className="app-card-tries">
          Tries remaining: <strong>{triesRemaining}</strong>
        </p>
      </div>
      <div className="app-card-right">
        <button className="app-card-btn" onClick={handleTestApp}>
          Test This App
        </button>
      </div>
    </div>
  );
};

export default AppCard;
